<template>
    <el-container>
        <el-header ref="header" :class="hasScroll==true?'header_scroll':'header_noscroll'">
            <base-header/>
        </el-header>
        <el-main :class="hasScroll==true?'main_scroll':'main_noscroll'">
            <router-view/>
        </el-main>
        <el-footer ref="footer" id='home-footer' height="180px">
            <base-footer/>
        </el-footer>
    </el-container>
</template>

<script>
    import baseHeader from '@/components/base/header.vue'
    import baseFooter from '@/components/base/footer.vue'

    export default {
        data() {
            return {
                mainHeight: 0,
				hasScroll:false,
				opacityStyle:{opacity:0}
            }
        },
        components: {
            baseHeader,
            baseFooter
        },
        computed: {},
		created(){
		    document.addEventListener('scroll', this.handleSroll)
		  },
		  beforeDestroy () {
		    document.removeEventListener('scroll', this.handleSroll);
		  },
        methods: {
			handleSroll(){
				const top=document.documentElement.scrollTop || document.body.scrollTop;
				//console.log('top'+top);
				if(top>60){
					this.hasScroll=true;
				}else{
					this.hasScroll=false;
				}
			}
		}
    }
</script>

<style scoped >
	.header_noscroll{
		background: none;
		z-index: 200;
		position:initial;
		width: 100%;
		height:10%;
	}
	.header_scroll{
		background: url(../../assets/base/top.png) no-repeat center;
		z-index: 200;
		position:fixed;
		width: 100%;
		height:10%;
	}
	.main_noscroll {
	    padding: 0px;
	    overflow-y: hidden;
	    margin-top: -4.6%;
	}
    .main_scroll {
        padding: 0px;
		overflow-y: hidden;
		margin-top: 4.6%;
    }
    .el-footer{
        padding: 0;
        overflow: hidden;
    }
    .el-container {
        min-height: 100%;
    }
</style>
